var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "file-wrapper relative"
  }, [_c("input", {
    ref: "excel-upload",
    staticStyle: {
      display: "none"
    },
    attrs: {
      type: "file",
      accept: ".xlsx, .xls"
    },
    on: {
      change: _vm.handleChange
    }
  }), _c("a-button", {
    staticStyle: {
      "z-index": "99"
    },
    attrs: {
      type: "primary",
      icon: "file-excel",
      size: "large",
      loading: _vm.loading
    },
    on: {
      click: _vm.handleUpload
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("上传Excel")) + " ")]), _c("p", {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t("请选择Excel上传 支持(xlsx,xls)格式")))])], 1), _vm.tableHead.length > 0 ? _c("a-card", {
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      hoverable: true,
      bordered: false
    }
  }, [_c("standard-table", {
    attrs: {
      pagination: false,
      tableData: _vm.tableData,
      tableHead: _vm.tableHead
    }
  })], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };